module.exports = __webpack_public_path__ + "img/8.cab993c4.jpg";